import { render, staticRenderFns } from "./paragraph-view-more.vue?vue&type=template&id=307c70a5&"
import script from "./paragraph-view-more.vue?vue&type=script&lang=ts&"
export * from "./paragraph-view-more.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports